import { createRoute } from '@tanstack/react-router';

import { StaffPage } from '@/components/admin/StaffPage';
import { TaskTab } from '@/components/admin/TaskTab';
import { seoHead } from '@/lib/seo/routeMeta';

import { Route as rootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/tasks',
  head: () => seoHead('/tasks'),
  component: TasksPage,
});

function TasksPage() {
  return (
    <StaffPage>
      <TaskTab />
    </StaffPage>
  );
}
